import { bridgelessRestApiClient } from '../clients'

export interface AccountResponse {
  account: {
    base_account: {
      address: string
      pub_key: {
        '@type': string
        key: string
      }
      account_number: string
      sequence: string
    }
  }
  code_hash?: string
}

export async function fetchAccount(address: string) {
  const { data } = await bridgelessRestApiClient.get<AccountResponse>(
    `/cosmos/auth/v1beta1/accounts/${address}`,
  )

  return data
}
